import { create } from "zustand";

type SignInMode = "signIn" | "signUp" | "optVerify";

interface SignInState {
  viewMode: SignInMode;
  signInMode: "signIn" | "signUp";
  signInModalVisible: boolean;
}

interface SignInActions {
  setViewMode: (mode: SignInMode) => void;
  setSignInModalVisible: (visible: boolean) => void;
}

type SignInStore = SignInState & SignInActions;

const initialState: SignInState = {
  viewMode: "signIn",
  signInMode: "signIn",
  signInModalVisible: false,
};

const useSignInStore = create<SignInStore>((set) => ({
  ...initialState,
  setViewMode: (mode) =>
    set(() => {
      if (mode === "signIn") {
        return { viewMode: mode, signInMode: "signIn" };
      }
      if (mode === "signUp") {
        return { viewMode: mode, signInMode: "signUp" };
      }

      return { viewMode: mode };
    }),
  setSignInModalVisible: (visible) => set(() => ({ signInModalVisible: visible })),
}));

export default useSignInStore;
